import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { useNavigate } from 'react-router-dom';
import { UserContext } from '@mirinae/react-auth';

import GlobalContext, { SyncContext } from '@mirinae/lessons/modules/contexts/global';
import EditorContext, { useEditorContext } from '@mirinae/lessons/editor/modules/contexts/editor';
import SelectContext, { useSelectContext } from '@mirinae/lessons/editor/modules/contexts/selection';
import LessonContainer from '@mirinae/lessons/editor/containers/LessonContainer';
import AnimationEditor from '@mirinae/lessons/editor/components/PropertySheets/elements/AnimationEditor';
import LessonSpecBox from '@mirinae/lessons/editor/components/ui/LessonSpecBox';

const EditorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 480px; 
    max-width: 480px;
    height: 100%;
    // height: 500px;
    font-family: Roboto;
    background: white;
    color: #6a6a6a;
    font-size: 11px;
    z-index: 140;
    border-right: thin solid lightgray;
    position: absolute;
    left: 0px;
`;

// eslint-disable-next-line import/no-mutable-exports
export let setAnimStep = null;

const Editor = () => {
    const globalContext = useContext(GlobalContext);
    const userState = useContext(UserContext);
    const selectContext = useSelectContext(globalContext);
    const editorContext = useEditorContext(userState, globalContext, selectContext);
    // const editor = useContext(EditorContext);
    // const selection = useContext(SelectContext);
    const navigate = useNavigate();
    editorContext.setNavigate(navigate);
    selectContext.setNavigate(navigate);

    // context for lessons player to synchronize state with editor without using a shared context (and the re-rendering problems that creates)
    // generalize and clean this up!
    const [sync, setSync] = useState({ animStep: null });

    useEffect(() => {
        setAnimStep = (animStep) => setSync({ ...sync, animStep });
        return async () => setAnimStep = null;
    }, []);

    return (
        <DndProvider backend={HTML5Backend}>
            <EditorContext.Provider value={editorContext}>
                <SelectContext.Provider value={selectContext}>
                    <SyncContext.Provider value={[sync, setSync]}>
                        <EditorWrapper id="editor">
                            <LessonContainer />
                        </EditorWrapper>
                        { editorContext.animationEditor.show && <AnimationEditor /> }
                        { editorContext.lessonSpecBox.show && <LessonSpecBox /> }
                    </SyncContext.Provider>
                </SelectContext.Provider>
            </EditorContext.Provider>
        </DndProvider>
    );
};

export default Editor;
